var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFusionLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 34,
    height: 34,
    rx: 17,
    stroke: "#353535",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.06465 16.5233C7.93348 16.2066 8.00598 15.8422 8.24828 15.5998L12.1037 11.7444C12.4348 11.4133 12.9712 11.4133 13.3022 11.7444C13.6332 12.0752 13.6332 12.6119 13.3022 12.9427L10.8934 15.3515H27.1525C27.6205 15.3515 28 15.7309 28 16.199C28 16.6671 27.6205 17.0465 27.1525 17.0465H8.84754C8.50477 17.0465 8.19582 16.8399 8.06465 16.5233ZM27.1525 18.9533H8.84746C8.37945 18.9533 8 19.3326 8 19.8007C8 20.2688 8.37945 20.6482 8.84746 20.6482H25.1066L22.6977 23.057C22.3668 23.3878 22.3668 23.9245 22.6977 24.2553C22.8632 24.4208 23.08 24.5036 23.297 24.5036C23.5138 24.5036 23.7307 24.4208 23.8962 24.2553L27.7517 20.3999C27.994 20.1576 28.0665 19.7931 27.9354 19.4765C27.8042 19.1598 27.4952 18.9533 27.1525 18.9533Z",
    fill: "#353535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFusionLogo);
export default __webpack_public_path__ + "static/media/fusionLogo.e64c7ce1f0e5c35ddb4a0933ee8fe775.svg";
export { ForwardRef as ReactComponent };